import styled from 'styled-components'

export const UsersFilterSearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const UsersFilterWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const UsersSearchWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const UsersFilterComponentWrapper = styled.div`
  width: 184px;
  border-radius: 4px;
  margin-right: 24px;
`

export const UsersManagementFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0 32px 0;
`

export const UsersManagementPageContainer = styled.div`
  padding-top: 32px;
  padding-left: 56px;
  padding-right: 56px;
`

export const SortingIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: rgba(32, 32, 32, 0.05);

  :hover {
    background: rgba(32, 32, 32, 0.2);

    > svg {
      fill-opacity: 1;
    }
  }
`

export const YellowStatusDot = styled.span`
  height: 8px;
  width: 8px;
  background-color: #ffcb00;
  border-radius: 50%;
  display: inline-block;
  margin-right: 16px;
`

export const RedStatusDot = styled.span`
  height: 8px;
  width: 8px;
  background-color: #e11900;
  border-radius: 50%;
  display: inline-block;
  margin-right: 16px;
`

export const GreenStatusDot = styled.span`
  height: 8px;
  width: 8px;
  background-color: #05944f;
  border-radius: 50%;
  display: inline-block;
  margin-right: 16px;
`
export const IconContainer = styled.div`
  margin-right: 12px;
  display: inline;
`

export const UsersSearchInputWrapper = styled.div`
  width: 544px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 8px;
`
export const ResponsiveComponent = styled.div`
  /* styles for all screen sizes */

  /* styles for screen widths of 1122px and below */
  @media screen and (max-width: 1122px) {
    width: 23rem;
    margin-bottom: 2rem;
    height: 2.5rem;
  }
`
